/* eslint-disable jsx-a11y/anchor-is-valid */
import type { FC } from "react";
import { TextInput, Select } from "flowbite-react";
import { HiOutlinePlus } from "react-icons/hi";
import { StandardForm, EntityFormDialog } from "@components";
import { useTranslation } from "react-i18next";

export interface IApiKeyCreateData {
  name: string;
  role: string;
}

export interface ApiKeyCreateModalProps {
  isShowing: boolean;
  onConfirm: (data: IApiKeyCreateData) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
}

export const ApiKeyCreateForm: FC<ApiKeyCreateModalProps> = (props) => {
  const { t } = useTranslation(["common", "user", "workspace"]); // Added workspace for potential new translations

  return (
    <StandardForm
      showHeader={false}
      fields={[
        {
          id: "name",
          label: t("common:name"), // Or a more specific t("workspace:api_keys.name_label")
          input: (
            <TextInput
              id="name"
              key="name"
              name="name"
              placeholder={t(
                "workspace:api_keys.name_placeholder",
                "E.g., My Integration Key",
              )} // Placeholder with default
              type="text"
              required={true}
            />
          ),
        },
        {
          id: "role",
          label: t("user:role"), // Reusing existing role label
          input: (
            <Select
              defaultValue="ReadOnly"
              id="role"
              key="role"
              name="role"
              required={true}
            >
              <option value="ReadOnly">ReadOnly</option>
              <option value="OrderDraft">OrderDraft</option>
              <option value="Administrator">Administrator</option>
              <option value="Owner">Owner</option>
            </Select>
          ),
        },
      ]}
      onConfirm={props.onConfirm}
      onCancel={props.onCancel}
      isSubmitting={props.isSubmitting}
      buttonConfirmText={t("workspace:api_keys.create_button")}
      buttonConfirmPrependIcon={<HiOutlinePlus className="mr-2 h-4 w-4" />}
      buttonCloseText={t("common:cancel")}
    />
  );
};

export const ApiKeyCreateModal: FC<ApiKeyCreateModalProps> = (props) => {
  const { t } = useTranslation(["common", "workspace"]);

  return (
    <EntityFormDialog
      title={t("workspace:api_keys.create_title", "Create API Key")} // Placeholder with default
      show={props.isShowing}
      onCancel={props.onCancel}
    >
      <ApiKeyCreateForm {...props} />
    </EntityFormDialog>
  );
};
